module.exports = __webpack_public_path__ + "1dfcb9b4343f2238b2adb82a52be5173.png";